<template>
	<div class="NewLists-div">
		<div class="NewLists-top">
			<Navbar></Navbar>
		</div>
    <div class="NewLists-banner">
      <img src="../assets/images/banner2.png" />
    </div>
    <div class="NewLists-content">
      <div class="NewLists-content-div">
        <div class="NewLists-con-tab" v-if="menuObj">
          <div class="NewLists-con-tabtitle">{{menuObj.name}}</div>
          <!-- <ul class="NewLists-con-tabul">
            <li v-for="(item, index) in newslist"
                :key="index"
                @mouseover="showactive(index)"
                @mouseout="hideactive()"
                @click="shownewlist(index)"
                class="NewLists-con-tabli"
                :class="activeindex == index ? 'NewLists-con-tabli-moveactive' : (showindex == index ? 'NewLists-con-tabli-active' : '')">{{item.tab}}</li>
          </ul> -->
          <ul class="NewLists-con-tabul">
            <router-link tag="li" v-for="(item, index) in menuObj.child"
                :key="index"
                class="NewLists-con-tabli"
                :to="{path: item.url}"
                :class="item.id == $route.query.menuId ? 'NewLists-con-tabli-active' : ''">{{item.name}}</router-link>
          </ul>
        </div>
        <div class="NewLists-con-news" v-if="detail">
          <div class="NewLists-news-tip">{{detail.title}}</div>
          <div class="NewLists-news-desc">
            <div class="NewLists-news-time">日期：{{detail.createTime}}</div>
            <!-- <div class="NewLists-news-author">作者：晟矽微</div> -->
          </div>
          <div class="NewLists-news-msg ql-editor" v-html="detail.content.replaceAll('/prod-api', '').replaceAll('http://admin.global-rainbow.com', '')">
          </div>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
import "@/common/quill.core.css"
import request from "../util/request";
	import Navbar from "../components/Navbar.vue";
	export default {
		name: "NewDetail",
		components: {
			Navbar
		},
		data() {
		  return {
        activeindex: -1, // 鼠标移入的
        showindex: 0, // 展示的新闻列表
        newslist:[],

        detail: null,
        
        menuObj: null,
		  }
		},
    watch: {
      $route() {
        this.getDetail()
        this.getChildMenu()
      }
    },
    async mounted() {
      this.getDetail()
        this.getChildMenu()
    },
    methods: {
      async getDetail() {
          this.detail = await request.get(`/article/detail?id=${this.$route.query.id}`)
      },
      async getChildMenu() {
        if(this.$route.query.parentMenuId) {
          let menuObj = await request.get(`/nav/listByParentId?parentId=${this.$route.query.parentMenuId}`)
          this.menuObj = menuObj
        }
      },
      showactive(num) {
        this.activeindex = num;
      },
      hideactive() {
        this.activeindex = -1;
      },
      shownewlist(num) {
        this.showindex = num;
      }
    }
	}
</script>

<style scoped>
  .NewLists-banner {
    width: 100%;
    min-width: 1200px;
    height: 350px;
  }
  
  .NewLists-banner img {
    width: 100%;
    height: 100%;
  }
  
  .NewLists-content {
    min-width: 1200px;
    background-color: #f5f5f5;
  }
  
  .NewLists-content-div {
    width: 1200px;
    margin: 0 auto;
    padding: 30px 0px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
  }
  
  .NewLists-con-tab,
  .NewLists-con-news {
    background-color: #fff;
    border-radius: 10px;
    overflow: hidden;
  }
  
  .NewLists-con-tab {
    margin-right: 10px;
    width: 180px;
    min-height: 250px;
    flex-shrink: 0;
  }
  
  .NewLists-con-tabtitle {
    font-size: 16px;
    font-weight: bold;
    color: #262626;
    padding: 10px 15px;
    box-sizing: border-box;
  }
  
  .NewLists-con-tabli {
    color: #787878;
    background-color: #f5f5f5;
    padding: 10px 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #fff;
    cursor: pointer;
    position: relative;
  }
  
  .NewLists-con-tabli-moveactive {
    color: #232CEA;
    background-color: rgba(35, 44, 234, 0.10);
  }
  
  .NewLists-con-tabli-active {
    color: #232CEA;
    font-weight: bold;
  }
  
  .NewLists-con-tabli-active::after {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    width: 2px;
    height: 100%;
    z-index: 1;
    background: #232cea;
  }
  
  .NewLists-con-news {
    flex-grow: 2;
    padding: 40px 30px;
    box-sizing: border-box;
  }
  
  .NewLists-news-tip {
    font-size: 18px;
    font-weight: bold;
    color: #262626;
    text-align: center;
  }
  
  .NewLists-news-desc {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #787878;
    font-size: 14px;
    margin-top: 15px;
  }
  
  .NewLists-news-time {
    margin-right: 20px;
  }
  
  .NewLists-news-msg {
    color: #787878;
    border-top: 1px solid #f5f5f5;
    margin-top: 30px;
    padding: 20px;
  }
</style>
<style>

  .NewLists-news-msg * {
    max-width: 100%;
  }
</style>